import React from 'react'
import moment from 'moment'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import CancelMobileServiceForm from '../forms/CancelMobileServiceForm'
import PaymentInformation from './PaymentInformation'
import globals from '../globals'
import Error from '../components/Error'

class CancelMobileService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            fee: null,
            errors: {},
            hasGenericError: false,
            isCancelled: false,
            requestedDate: ''
        }

        this.type = 'mobile'
    }

    componentDidMount () {
	    DataSource.getData(`/api/getIsCancelled/${this.props.serviceId}`, response => {
            this.setState({
                isCancelled: response.existing,
                requestedDate: response.existing ? response.requested_date : ''
            })
        })
    }

    calcTerminationFee (date) {
        const newDate = moment(date)
        this.reset()
        DataSource.postData(
            '/api/postEarlyTerminationFee',
            {
                serviceId: this.props.serviceId,
                date: newDate.format('YYYY-MM-DD')
            },
            this.handleSuccess.bind(this),
            this.handleFailure.bind(this)
        )
    }

    handleSuccess (response) {
        this.setState({
            fee: `$${globals.addDecimals(response.data.early_cancel_fee)}`
        })
    }

    handleFailure (response) {
        if (response.response.status === 422) {
            this.setState({ errors: response.response.data.errors })
        } else {
            this.setState({ hasGenericError: true })
            globals.handleError(response.message, response)
        }
    }

    hasErrors () {
        return Object.keys(this.state.errors).length > 0
    }

    reset () {
        this.setState({
            fee: null,
            errors: {},
            hasGenericError: false
        })
    }

    render () {
        const Errors = () => {
            if (this.hasErrors()) {
                return <Error errors={this.state.errors} />
            }

            if (this.state.hasGenericError) {
                return <div className='row-error'>Oops! Something went wrong. Please try again to see if the issue persists.</div>
            }
        }

        return (
            <div>
                <div className='module' style={{ overflow: 'visible' }}>
                    <Heading title={this.props.title} />
                    <ModuleWithLoader isLoaded className='p-4'>
                        {this.state.isCancelled
                            ? <div className='row'>
                                <div className='col-12 text-center'>
                                    <p>Your service is scheduled to be cancelled on <span className='bold'>{this.state.requestedDate}</span>.</p>
                                </div>
                              </div>
                            : <React.Fragment>
                                <div className='row'>
                                    <div className='col-12 text-center'>
                                        <p>You can cancel your service below:</p>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-6 offset-md-3'>
                                        <CancelMobileServiceForm
                                            serviceId={this.props.serviceId}
                                            mobile={this.props.serviceDetails.serviceNo}
                                            endDate={this.props.serviceDetails.contractEndDate}
                                            fee={this.state.fee}
                                            handleChange={this.calcTerminationFee.bind(this)}
                                            handleSuccess={() => globals.pushEvent('CancelMobileServiceSubmit', { type: this.props.type })}
                                            errors={Errors()}
                                        />
                                    </div>
                                </div>
                              </React.Fragment>}
                    </ModuleWithLoader>
                </div>
                {this.state.isCancelled ? '' : <PaymentInformation />}
            </div>
        )
    }
}

export default CancelMobileService



// WEBPACK FOOTER //
// ./resources/js/modules/CancelMobileService.js